import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";
import i18n from "./i18n";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function pageHead(titleKey: string) {
  return {
    meta: [{ title: `${i18n.t(titleKey)} | brinked.ai` }],
  };
}
